import React, { useState } from "react";
import { toast } from "react-toastify";
import "./ModalForm.css";
import { href, useNavigate } from "react-router-dom"; // ← useNavigate

import { FaUser } from "react-icons/fa";
import { MdBusinessCenter, MdEmail, MdPhone, MdLocationOn } from "react-icons/md";

export default function ModalForm() {
  const [formData, setFormData] = useState({
    name: "",
    companyName: "",
    email: "",
    workEmail: "",
    phone: "",
    country: "",
    businessCategory: "",
    message: "",
  });

  const navigate = useNavigate(); // ← navigation hook

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${import.meta.env.VITE_API_URL}/submit-form`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          submittedAt: new Date().toISOString(),
        }),
      });

      if (res.ok) {
        // toast.success("Your responce is sent successfully!");
        const data = await res.json()
        toast.success(data.message)
        setFormData({
          name: "",
          companyName: "",
          email: "",
          workEmail: "",
          phone: "",
          country: "",
          businessCategory: "",
          message: "",
        });
         navigate("/"); // go home after success
      } else {
        toast.error("Save failed");
        navigate("/"); // go home even on failure
      }
    } catch (err) {
      console.error(err);
      toast.error("Network error");
      navigate("/"); // go home on error
    }
  };

  return (
    <div className="cf_wrapper">
      <div className="cf_container">
        <h2 className="cf_title">
          Tell us about <span className="cf_gold_gradient">you</span>
        </h2>

        <form onSubmit={handleSubmit} className="cf_form">
          {/* Row 1: Name + Company */}
          <div className="cf_form_row">
            <div className="cf_form_group">
              <div className="cf_input_icon_wrapper">
                <FaUser size={16} className="cf_input_icon" />
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Full name"
                  className="cf_input_field"
                />
              </div>
            </div>

            <div className="cf_form_group">
              <div className="cf_input_icon_wrapper">
                <MdBusinessCenter size={16} className="cf_input_icon" />
                <input
                  type="text"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  required
                  placeholder="Company name "
                  className="cf_input_field"
                />
              </div>
            </div>
          </div>

          {/* Row 2: Email + Work Email */}
          <div className="cf_form_row">
            <div className="cf_form_group">
              <div className="cf_input_icon_wrapper">
                <MdEmail size={16} className="cf_input_icon" />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="email"
                  className="cf_input_field"
                />
              </div>
            </div>

            {/* <div className="cf_form_group">
              <div className="cf_input_icon_wrapper">
                <MdEmail size={16} className="cf_input_icon" />
                <input
                  type="email"
                  name="workEmail"
                  value={formData.workEmail}
                  onChange={handleChange}
                  placeholder="Work or business email"
                  className="cf_input_field"
                />
              </div>
            </div> */}
             <div className="cf_form_group">
              <div className="cf_input_icon_wrapper">
                <MdPhone size={16} className="cf_input_icon" />
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Contact number"
                  className="cf_input_field"
                />
              </div>
            </div>

          </div>

          {/* Row 3: Phone + Country */}
          <div className="cf_form_row">
           

            <div className="cf_form_group">
              <div className="cf_input_icon_wrapper">
                <MdLocationOn size={16} className="cf_input_icon" />
                <input
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  placeholder="Country (e.g. India)"
                  className="cf_input_field"
                />
              </div>
            </div>


             <div className="cf_form_group">
            <div className="cf_input_icon_wrapper">
              <MdBusinessCenter size={16} className="cf_input_icon" />
              <select
                name="businessCategory"
                value={formData.businessCategory}
                onChange={handleChange}
                required
                className="cf_input_field cf_input_select"
               >
                <option className="cf_select_option"  value="">
                  Select business category
                </option>
                <option className="cf_select_option" value="startup">
                  Startup
                </option>
                <option className="cf_select_option" value="msme">
                  MSME
                </option>
                <option className="cf_select_option" value="mid to large">
                  Mid to Large
                </option>
                <option className="cf_select_option" value="large enterprise">
                  Large Enterprise
                </option>
              </select>
            </div>
          </div>
          </div>

          {/* Business Category – select */}
         

          {/* Message */}
          <div className="cf_form_group">
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows={4}
              placeholder="Tell us about your goals, challenges, and what you’d like to discuss with BAIREES."
              className="cf_textarea_field"
            />
          </div>

          {/* Buttons */}
          <div className="cf_form_actions">
            <a href="/">
            <button
              type="button"
              className="cf_button cf_button_cancel"
              onClick={() => navigate("/")}
            >
              Cancel
            </button>
            </a>
            
            <button type="submit" className="cf_button cf_button_submit">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}